(() => {
  const SELECTORS = {
    toggle: "[data-model-navigation-toggle]",
    panel: "[data-model-navigation-panel]",
    link: "[data-model-navigation-link]"
  };

  class ModelNavigation extends HTMLElement {
    constructor() {
      super();

      this.toggleButton = this.querySelector(SELECTORS.toggle);
      this.panel = this.querySelector(SELECTORS.panel);
      this.mobileMedia = window.matchMedia("(max-width: 767.98px)");
      this.handleToggle = this.handleToggle.bind(this);
      this.handleDocumentPointerDown = this.handleDocumentPointerDown.bind(this);
      this.handleDocumentKeyDown = this.handleDocumentKeyDown.bind(this);
      this.handleLinkClick = this.handleLinkClick.bind(this);
      this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
    }

    connectedCallback() {
      if (!this.toggleButton || !this.panel || this.dataset.initialized === "true") {
        return;
      }

      this.dataset.initialized = "true";
      this.toggleButton.addEventListener("click", this.handleToggle);
      this.panel.addEventListener("click", this.handleLinkClick);
      document.addEventListener("pointerdown", this.handleDocumentPointerDown);
      document.addEventListener("keydown", this.handleDocumentKeyDown);
      this.mobileMedia.addEventListener("change", this.handleBreakpointChange);
    }

    disconnectedCallback() {
      if (!this.toggleButton || !this.panel) {
        return;
      }

      this.toggleButton.removeEventListener("click", this.handleToggle);
      this.panel.removeEventListener("click", this.handleLinkClick);
      document.removeEventListener("pointerdown", this.handleDocumentPointerDown);
      document.removeEventListener("keydown", this.handleDocumentKeyDown);
      this.mobileMedia.removeEventListener("change", this.handleBreakpointChange);
      delete this.dataset.initialized;
    }

    get isOpen() {
      return this.toggleButton.getAttribute("aria-expanded") === "true";
    }

    open() {
      this.panel.hidden = false;
      this.toggleButton.setAttribute("aria-expanded", "true");
      this.panel.classList.remove("is-open");

      window.requestAnimationFrame(() => {
        this.panel.classList.add("is-open");
      });
    }

    close({ returnFocus = false } = {}) {
      if (!this.isOpen) {
        return;
      }

      this.toggleButton.setAttribute("aria-expanded", "false");
      this.panel.classList.remove("is-open");
      this.panel.hidden = true;

      if (returnFocus) {
        this.toggleButton.focus();
      }
    }

    handleToggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    handleDocumentPointerDown(event) {
      if (this.isOpen && !this.contains(event.target)) {
        this.close();
      }
    }

    handleDocumentKeyDown(event) {
      if (this.isOpen && event.key === "Escape") {
        event.preventDefault();
        this.close({ returnFocus: true });
      }
    }

    handleLinkClick(event) {
      if (event.target.closest(SELECTORS.link)) {
        this.close();
      }
    }

    handleBreakpointChange(event) {
      if (!event.matches) {
        this.close();
      }
    }
  }

  if (!customElements.get("model-navigation")) {
    customElements.define("model-navigation", ModelNavigation);
  }
})();
